import script from "./TopCreator.vue?vue&type=script&setup=true&lang=js"
export * from "./TopCreator.vue?vue&type=script&setup=true&lang=js"

import "./TopCreator.vue?vue&type=style&index=0&id=9d195a0c&lang=scss"

const __exports__ = script;

export default __exports__